module.exports = __webpack_public_path__ + "static/dcom3-2947f97378637de282798aac7e989990.png";